module.exports = __webpack_public_path__ + "img/taxid.29583d53.png";